import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Avatar,
  Box,
  Badge,
  Menu,
  Button,
  List,
  Divider,
  Hidden
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MenuListItem from '../left_side_bar/menu/item';
import DataHelper from 'eebac/utils/dataHelper';


const StyledBadge = withStyles({
  badge: {
    backgroundColor: 'var(--success)',
    color: 'var(--success)',
    boxShadow: '0 0 0 2px #fff',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""'
    }
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0
    }
  }
})(Badge);

const MenuList = props => {
  const { items } = props;

  return (
    <List className="p-0">
      {items.map(
        (item) => <MenuListItem
          depth={0}
          href={item.to}
          icon={item.icon}
          key={item.label}
          label={item.badge}
          title={item.label}
        />
      )}
    </List>
  );
};

MenuList.propTypes = {
  items: PropTypes.array
};

function HeaderUserbox(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const {
    navItems,
    userBoxData
  } = props;

  const content = navItems.content ? navItems.content : [];
  let items = [];
  content.forEach(item => {
    if (item.showInUserBox) {
      items = item.content;
    }
  });

  const onUserBoxOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const onUserBoxClose = () => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <Button
        color="inherit"
        onClick={onUserBoxOpen}
        className="text-capitalize px-3 text-left btn-inverse d-flex align-items-center">
        <Box>
          <StyledBadge
            overlap="circle"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            variant="dot">
            <Avatar sizes="44" alt={userBoxData.username}
              imgProps={{
                style: { objectFit: "fill" }
              }}

              src={DataHelper.addBase64ToImage(userBoxData.avatar)} className="bg-plum-plate-new" />
          </StyledBadge>
        </Box>
        <Hidden smDown>
          <div className="d-xl-block pl-1">
            <div className="font-weight-bold line-height-1">
              <Box component="div" style={{ maxWidth: "150px", whiteSpace: "nowrap", overflow: "hidden" }}
                textOverflow="ellipsis">
                {userBoxData.username}
              </Box>
            </div>
          </div>
        </Hidden>
        <span className="pl-1 pl-xl-3">
          <FontAwesomeIcon icon={['fas', 'angle-down']} className="opacity-5" />
        </span>
      </Button>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        onClose={onUserBoxClose}
        className="ml-2">
        <div className="dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
          <List className="text-left bg-transparent d-flex align-items-center flex-column pt-0">
            <Box>
              <StyledBadge
                overlap="circle"
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                variant="dot">
                <Avatar sizes="44" alt={userBoxData.username}
                  imgProps={{
                    style: { objectFit: "fill" }
                  }}
                  className="bg-plum-plate-new"
                  src={DataHelper.addBase64ToImage(userBoxData.avatar)} />
              </StyledBadge>
            </Box>
            <div className="pl-3 ">
              <div className="font-weight-bold text-center pt-2 line-height-1">
                <Box component="div" style={{ maxWidth: "150px", whiteSpace: "nowrap", overflow: "hidden",  textTransform : "capitalize" }}
                  textOverflow="ellipsis">
                  {userBoxData.username}
                </Box>
              </div>
            </div>
            <Divider className="w-100 mt-2" />

            <MenuList items={items} />
          </List>
        </div>
      </Menu>
    </Fragment>
  );
}

HeaderUserbox.defaultProps = {
  navItems: {},
  userBoxData: {}
}

const mapStateToProps = state => ({
  userBoxData: state.USERBOX_DATA
});

export default connect(mapStateToProps)(HeaderUserbox);